'use strict';

/**
 * @function
 * @description Initializes the tooltip-content and layout
 */
const tooltip = {
    init: function () {
    $('.tooltip').tooltip({
        items: '.tooltip',
        track: true,
        open: function(event, ui){
            if($(this).find('.shipping-tooltip').length > 0){
                $('.ui-tooltip').addClass('shipping-tooltip-container');
            }
        },
        content: function () {
            return $(this).find('.tooltip-content').html();
        }
    });

    /* Click tooltip events */
    $(document).on('click', '.tooltip-touch .tooltip-anchor', function(e) {
        e.preventDefault();
        $(this).siblings('.tooltip-text').removeClass('hide');
    }).on('click', '.tooltip-touch .tooltip-text .button-close', function() {
        $(this).closest('.tooltip-text').addClass('hide');
    });

    $('.share-link').on('click', function (e) {
        e.preventDefault();
        var target = $(this).data('target');
        if (!target) {
            return;
        }
        $(target).toggleClass('active');
    });
    
    $('.password-reset').click(function(e) {
        $('.menu-utility-content').removeClass('is-open');
    });
    }
}

export default tooltip;

